module.exports = __webpack_public_path__ + "img/4.bc18e4a4.png";